import { render, staticRenderFns } from "./communityPublicityManageList.vue?vue&type=template&id=1c4912c6&scoped=true"
import script from "./communityPublicityManageList.vue?vue&type=script&lang=js"
export * from "./communityPublicityManageList.vue?vue&type=script&lang=js"
import style0 from "./communityPublicityManageList.vue?vue&type=style&index=0&id=1c4912c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4912c6",
  null
  
)

export default component.exports